module.exports = __webpack_public_path__ + "static/img/practiceSystem_08.0e7d6e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/practiceSystem_08.png
// module id = bR+v
// module chunks = 23